//http://jsfiddle.net/jfhartsock/cM3ZU/
//https://stackoverflow.com/questions/4413590/javascript-get-array-of-dates-between-2-dates
Date.prototype.addDays = function (days) {
    var dat = new Date(this.valueOf())
    dat.setDate(dat.getDate() + days);
    return dat;
}

export default {
    name: "Utils",
    getUsersWelcomeToXaddenPost() {
        var user = JSON.parse(localStorage.getItem("user"));
        return {
            id: 0,
            user_id: user.id,
            advert_id: 0,
            has_been_claimed: 0,
            is_claim_correct: 0,
            claim_value_scored: 0,
            date_claimed: "",
            date_claimed_timestamp: 757585,
            has_been_ignored: 0,
            has_expired: 0,
            date_ignored: "",
            date_ignored_timestamp: 7866,
            claim_value: 0,
            date_expired: "",
            date_expired_timestamp: 85859,
            date_to_expire: "",
            date_to_expire_timestamp: 76869,
            date_posted: "",
            date_posted_timestamp: 749933
        };
    },
    getUsersWelcomeToXaddenNotification() {
        var user = JSON.parse(localStorage.getItem("user"));
        return {
            id: 0,
            message_identity: "000000000",
            user_id: user.id,
            is_read: 1,
            title: "Welcome to xaddden",
            message: "Xadden is a social rewarding network",
            icon: "mdi-user",
            target_platform: "android_app",
            deep_link: "",
            date_posted: "",
            date_posted_timestamp: 749933,
            date_read: "",
            date_read_timestamp: 749933
        };
    },
    comma(val) {
        //https://stackoverflow.com/questions/2901102/how-to-print-a-number-with-commas-as-thousands-separators-in-javascript
        var t = parseFloat(val);
        var bt = t.toLocaleString();
        return bt;
    },
    pad0(val) {
        var temp = val.toString();
        if (temp.length < 2) {
            temp = "0" + temp;
        }
        return temp;
    },
    get_dates_inbetween(start_date, end_date, formater) {
        if (typeof formater != 'function') {
            formater = (dt) => { return dt; };
        }
        //http://jsfiddle.net/jfhartsock/cM3ZU/
        //https://stackoverflow.com/questions/4413590/javascript-get-array-of-dates-between-2-dates


        function getDates(startDate, stopDate) {
            var dateArray = new Array();
            var currentDate = startDate;
            while (currentDate <= stopDate) {
                dateArray.push(currentDate)
                currentDate = currentDate.addDays(1);
            }
            return dateArray;
        }

        var res = [];
        var dateArray = getDates(start_date, end_date);
        for (var i = 0; i < dateArray.length; i++) {
            //console.log(dateArray[i].toString());
            var dt = dateArray[i];
            res.push(formater(dt));
        }
        return res;
    },
    validate: {
        is_required: (msg) => {
            if (typeof msg != 'string') {
                msg = "Value is required";
            }
            return (v) => {
                v = (v) ? v.toString().trim() : "";
                return !!v || msg;
            };
        },
        min_words: (num, msg) => {
            if (typeof num != 'number' || num <= 1) {
                num = 2;
            }
            if (typeof msg != 'string') {
                msg = "Value must be at least be " + num + " words long";
            }
            return (v) => {
                v = (v) ? v.trim().split(" ") : [];
                var temp = [];
                for (let index = 0; index < v.length; index++) {
                    const word = v[index].trim();
                    if (word.length > 0) {
                        temp.push(word);
                    }
                }
                return temp.length >= num || msg;
            };
        },
        min_max_length: (min, max, msg) => {
            if (typeof min != 'number' || min <= 1) {
                min = 2;
            }
            if (typeof max != 'number' || max > 1000 || max <= min) {
                max = 1000;
            }
            if (typeof msg != 'string') {
                msg = "Value length must be at between " + min + " and " + max + " letters long";
            }
            return (v) => {
                v = (v) ? v.trim() : "";
                return (v.length >= min && v.length <= max) || msg;
            };
        },
        max_length: (max, msg) => {
            if (typeof max != 'number' || max > 1000) {
                max = 1000;
            }
            if (typeof msg != 'string') {
                msg = "Value length must be at less than " + (max + 1) + " letters long";
            }
            return (v) => {
                v = (v) ? v.trim() : "";
                return (v.length <= max) || msg;
            };
        },
        email_format: (msg) => {
            /*https://stackoverflow.com/questions/46155/how-to-validate-an-email-address-in-javascript*/
            return (v) => {
                const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(v) || msg;
            }
        },
        if_provided_email_format: function(msg) {
            var is_required_va = this.is_required(msg);
            var email_va = this.email_format(msg);
            return (v) => {
                var is_provided = is_required_va(v);
                if(is_provided == true){
                    //run the validation
                    var is_valid_email = email_va(v);
                    return (is_valid_email == true) || msg;
                }
                //return true
                return true;
            }
        },
        if_provided_phone_number: function(msg,is_officee = false) {
            var is_required_va = this.is_required(msg);
            var phone_va = this.phone_number(msg,is_officee);
            return (v) => {
                var is_provided = is_required_va(v);
                if(is_provided == true){
                    //run the validation
                    var is_phone_valid = phone_va(v);
                    return (is_phone_valid == true) || msg;
                }
                //return true
                return true;
            }
        },
        phone_number: function(msg,is_officee = false){
            var numeric_va = this.numeric(msg);
            return (v) => {
                if (!v) {
                    return msg;
                }
                v = v.toString().trim();
                //should only have digits
                var temp = v.replace("+","").replaceAll(" ","");
                var is_numeric = numeric_va(temp);
                if(is_numeric == false){
                    return msg;
                }

                //77393543
                if (is_officee == false && (temp.length < 8 || v.length > 15)) {
                    return msg;
                }
                if (is_officee == true &&v.length > 15) {
                    return msg;
                }

                //nyd
                //validate office numbers
                

                //https://www.npmjs.com/package/libphonenumber-js
                //nyd
                //add libphonenumber to validate phone numbers
                return (v != undefined) || msg;
            }
        },
        email_format_or_phone: function (msg,is_officee = false) {
            var email_va = this.email_format(msg);
            var phone_va = this.phone_number(msg,is_officee);
            return (v) => {
                if (!v) {
                    return msg;
                }
                var is_email_valid = email_va(v);
                var is_phone_valid = phone_va(v);
                //console.log("vals ", is_email_valid, is_phone_valid);
                return (is_email_valid == true || is_phone_valid == true) || msg;
            }
        },

        /* eslint-disable no-useless-escape */
        equal_to: (v2, msg) => {
            return (v) => {
                return (!!v && v) === v2 || msg;
            }
        },
        length: (len, msg) => {
            return (v) => {
                var temp_len = (v) ? (v.length ? v.length : v.toString().length) : 0;
                return (v && (temp_len == len)) || msg;
            }
        },
        numeric: (msg) => {
            return (v) => {
                const re = /^\d+$/;
                return re.test(v) || msg;
            }
        },
        min: (num, msg) => {
            return (v) => {
                v = parseFloat(v);
                //console.log("comp:", v, num, (v >= num));
                return (v >= num) || msg;
            }
        },
        dob_min_age: (num, msg) => {
            return (v) => {
                v = v.toString();
                var age = 0;
                var dt = new Date(v);
                var dob_year = dt.getFullYear();
                var this_year = (new Date()).getFullYear();
                age = this_year - dob_year;
                return (age >= num) || msg;
            }
        },
        is_date: (msg) => {
            return (v) => {
                var is_valid = true;
                v = (v) ? v.toString() : "";
                //var dateformat = /^(0?[1-9]|[12][0-9]|3[01])[\/\-](0?[1-9]|1[012])[\/\-]\d{4}$/;
                var dateformat = /^\d{4}[\/\-](0?[1-9]|1[012])[\/\-](0?[1-9]|[12][0-9]|3[01])$/;
                // Match the date format through regular expression
                if (v.match(dateformat)) {
                    //Test which seperator is used '/' or '-'
                    var opera1 = v.split('/');
                    var opera2 = v.split('-');
                    var lopera1 = opera1.length;
                    var lopera2 = opera2.length;
                    // Extract the string into month, date and year
                    var pdate = null;
                    if (lopera1 > 1) {
                        pdate = v.split('/');
                    }
                    else if (lopera2 > 1) {
                        pdate = v.split('-');
                    }
                    var yy = parseInt(pdate[0]);
                    var mm = parseInt(pdate[1]);
                    var dd = parseInt(pdate[2]);
                    // Create list of days of a month [assume there is no leap year by default]
                    var ListofDays = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
                    if (mm == 1 || mm > 2) {
                        if (dd > ListofDays[mm - 1]) {
                            is_valid = false;
                        }
                    }
                    if (mm == 2 && is_valid) {
                        var lyear = false;
                        if ((!(yy % 4) && yy % 100) || !(yy % 400)) {
                            lyear = true;
                        }
                        if ((lyear == false) && (dd >= 29)) {
                            is_valid = false;
                        }
                        if ((lyear == true) && (dd > 29)) {
                            is_valid = false;
                        }
                    }
                }
                else {
                    is_valid = false;
                }
                return (is_valid) || msg;
            }
        }
    },
    can_access(user, menu_item) {
        //if user is super admin, they can access anything
        var can_access = false;
        if (user) {
            for (let index = 0; index < user.user_roles.length; index++) {
                const user_role = user.user_roles[index];
                var role_name = user_role.role.name;
                if (menu_item.roles.indexOf(role_name) >= 0) {
                    can_access = true;
                    break;
                }
            }
        }
        if (can_access == true) {
            return true;
        }

        var is_public = menu_item.roles.indexOf("public") >= 0;
        if (is_public) {
            return true;
        }
        return false;
    },
    is_admin(user) {
        if (user) {
            for (let index = 0; index < user.user_roles.length; index++) {
                const user_role = user.user_roles[index];
                var role_name = user_role.role.name;
                if (role_name == "backofficcee" || role_name == "super role") {
                    return true;
                }
            }
        }
        return false
    },
    get_default_page_attr() {
        return {
            title: "",
            crumps: [
            ],
            navbar_cols: 4
        };
    },
    default_icon: "mdi-file-cabinet",
    default_thumbnail:
        "https://res.cloudinary.com/solidcare-img-cloud/image/upload/v1604313402/botswana%20services/categories/categories_taygdc.jpg",
    get_default_category() {
        return {
            id: 0,
            name: "",
            icon: this.default_icon,
            thumb_nail: this.default_thumbnail,
            description: "",
            is_top_category: 0,
            top_category_level: 0,
        };
    },
    default_holidays_thumbnail: "https://res.cloudinary.com/solidcare-img-cloud/image/upload/v1606236446/botswana%20services/website%20assets/holidays_jryx9d.jpg",
    default_business_logo: "https://res.cloudinary.com/solidcare-img-cloud/image/upload/v1606236446/botswana%20services/website%20assets/holidays_jryx9d.jpg",
    default_business_banner: "https://res.cloudinary.com/solidcare-img-cloud/image/upload/v1601730151/botswana%20services/website%20assets/Botswana-Stock-Exchange-COVID-19-Africa-Watch-1030x391_popbyj.png", //country botswana
    sub_categories_limit: 3,
    date_str_to_words(date) {
        var word = "";
        var month_words = ["", "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        if (date) {
            var [year, month, day] = date.split('-');
            month = parseInt(month);
            day = parseInt(day);
            if (month) {
                word = month_words[month];
            }
            if (day == 1 || day == 21 || day == 31) {
                word = day + "ST " + word;
            } else if (day == 2 || day == 22 || day == 32) {
                word = day + "ND " + word;
            } else if (day == 3 || day == 23 || day == 33) {
                word = day + "RD " + word;
            } else {
                word = day + "TH " + word;
            }
        }

        return word;
    },
    date_str_to_php_time(dt) {
        var dt = new Date(dt);
        var time = dt.getTime();
        var dtTime = (time == 0) ? time : (time / 1000);
        return dtTime;
    },
    php_time_to_js_date_str(t, withTime = false) {
        var dtTime = t * 1000;
        var startDate = new Date();
        startDate.setTime(dtTime);
        var str = this.get_today_date_str(startDate, withTime);
        return str;
    },
    get_today_date_str: function (dt, withTime) {
        var today = dt;
        if (typeof today == "undefined" || today == null) {
            today = new Date();
        }
        if (typeof withTime == "undefined" || withTime == null) {
            withTime = false;
        }
        var m = (1 + today.getMonth());
        m = m < 10 ? ("0" + m) : m;
        var d = today.getDate();
        d = d < 10 ? ("0" + d) : d;
        var todatStr = today.getFullYear() + "-" + m + "-" + d;
        if (withTime == true) {
            todatStr = todatStr + " " + today.toLocaleTimeString();
        }
        return todatStr;
    },
    get_default_business: function(){
        var temp = {
            user_id: 0,
            name:"",
            tag_line:"",
            description:"",
            logo: this.default_business_logo,
            banner: this.default_business_banner,
            is_added_by_admin:0,
            added_by_id:0,
            is_assigned_to_owner:0,
            former_owner_id:0,
            assigned_by_id:0,
            joined_on:"1970-01-01",
            joined_on_timestamp:0,
            assigned_on:"1970-01-01",
            assigned_on_timestamp:0,
            is_main_branch:0,
            is_branch_of_id:-1,
            office_phone_number1:"",
            office_phone_number2:"",
            mobile_phone_number1:"",
            mobile_phone_number2:"",
            email_address_1:"",
            email_address_2:"",
            email_address_3:"",
            website_1:"",
            website_2:"",
            website_3:"",
            fax_number:"",
            pobox_number:"",
            facebook_link:"",
            twitter_link:"",
            instagram_link:"",
            youtube_link:"",
            linked_link:"",
            is_approved:0,
            is_verified:0,
            verified_on:"1970-01-01",
            verified_on_timestamp:0,
            verified_by_id:0,
            manual_directions:"",
            physical_address:"",
            lat:0,
            lng:0,
            time_zone:0,
            country_id:1, //botswana
            district_id:1,
            city_id:1,
            ward_id:1,
            street_id:1,
            tags:"",
            qr_code:"",
            views_count:0,
            reviews_count:0,
            rating:0,
            is_local_company:1,
            is_local_company_specified:0,
            monday_openning_time_display:"08:00 am",
            monday_openning_time_value:8.0,
            monday_closing_time_value: 24.59,
            monday_closing_time_display:"24:59",
            tuesday_openning_time_display:"08:00 am",
            tuesday_openning_time_value: 8.0,
            tuesday_closing_time_value: 24.59,
            tuesday_closing_time_display: "24:59",
            wednesday_openning_time_display:"08:00 am",
            wednesday_openning_time_value: 8.0,
            wednesday_closing_time_value: 24.59,
            wednesday_closing_time_display: "24:59",
            thursday_openning_time_display:"08:00 am",
            thursday_openning_time_value: 8.0,
            thursday_closing_time_value: 24.59,
            thursday_closing_time_display: "24:59",
            friday_openning_time_display:"08:00 am",
            friday_openning_time_value: 8.0,
            friday_closing_time_value: 24.59,
            friday_closing_time_display: "24:59",
            saturday_openning_time_display: "08:00 am",
            saturday_openning_time_value: 8.0,
            saturday_closing_time_value:24.59,
            saturday_closing_time_display: "24:59",
            sunday_openning_time_display:"08:00 am",
            sunday_openning_time_value: 8.0,
            sunday_closing_time_value: 24.59,
            sunday_closing_time_display: "24:59",
            hollidays_openning_time_display: "08:00 am",
            hollidays_openning_time_value: 8.0,
            hollidays_closing_time_value: 24.59,
            hollidays_closing_time_display: "24:59",
            doc_idcopy_url:"",
            doc_cert_incoporation_url:"",
            doc_extr_comp_document_url:"",
            doc_cert_tax_url:"",
            doc_trade_liscence_url:"",
            doc_registration_cert_url:"",
            belongings: [],
            business_holliday_schedules: [],
            pictures: [],
            reviews: [],
            ratings: [],
            products: [],
            services:[],
            business_messages:[],
            district:{id:1, name: ""},
            city_id:{id:1, name: ""},
            ward_id:{id:1, name: ""},
            street_id:{id:1, name: ""},
            user: {
                id: 0,
                name: "",
                first_name: "",
                last_name:""
            }
        };
        return temp;
    }
}